import { Injectable } from '@angular/core';

type localStorageKey = 'app_loginRedirectUrl' | 'app_attendance';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private get(key: localStorageKey) {
    return localStorage.getItem(key);
  }

  private set(key: localStorageKey, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('Local Storage cheio ou desabilitado.');
    }
  }

  public has(key: localStorageKey) {
    return key in localStorage;
  }

  public getJson(key: localStorageKey) {
    return JSON.parse(this.get(key));
  }

  public setJson(key: localStorageKey, value: any) {
    this.set(key, JSON.stringify(value));
  }

  public remove(key: localStorageKey) {
    localStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
  }
}
